import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1 } from '../../../styles';
import { DirectTaxForm } from "../../Common/TaxPayment/Forms";


let DirectTaxModal = (props) => {

    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {`${props.direct_tax.is_edit ? "Update" : "Create"} Direct Tax`}
            </Text1>
        )
    };

    return (
        <EaseModal
            width={900}
            title={false}
            visible={props.visible}
            onCancel={props.toggleDirectTaxChallanModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <DirectTaxForm
                direct_tax={props.direct_tax}
                user={props.user}
                toggleDirectTaxChallanModal={props.toggleDirectTaxChallanModal}
                fetchChallanList={props.fetchChallanList}
            />
        </EaseModal>
    )


};


export { DirectTaxModal };
